export const REQUEST_FEEDBACK_REPLY = 'REQUEST_FEEDBACK_REPLY'
export const CHECK_TOKEN_FEEDBACK_REPLY_FORM = 'CHECK_TOKEN_FEEDBACK_REPLY_FORM'
export const SET_FEEDBACK_REPLY_FORM = 'SET_FEEDBACK_REPLY_FORM'
export const SEND_FEEDBACK_REPLY_FORM = 'SEND_FEEDBACK_REPLY_FORM'
export const SET_INVALID_TOKEN = 'SET_INVALID_TOKEN'



// WEBPACK FOOTER //
// ./app/actions/feedbackReplyForm/constants.js